var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconPrivate18 = function SvgAIconPrivate18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    stroke: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 8.5C4.5 7.94772 4.94772 7.5 5.5 7.5H12.5C13.0523 7.5 13.5 7.94772 13.5 8.5V14C13.5 14.5523 13.0523 15 12.5 15H5.5C4.94772 15 4.5 14.5523 4.5 14V8.5Z",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 3V3C7.34315 3 6 4.34315 6 6V7.5H12V6C12 4.34315 10.6569 3 9 3Z",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAIconPrivate18 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE4IDE4IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNC41IDguNUM0LjUgNy45NDc3MiA0Ljk0NzcyIDcuNSA1LjUgNy41SDEyLjVDMTMuMDUyMyA3LjUgMTMuNSA3Ljk0NzcyIDEzLjUgOC41VjE0QzEzLjUgMTQuNTUyMyAxMy4wNTIzIDE1IDEyLjUgMTVINS41QzQuOTQ3NzIgMTUgNC41IDE0LjU1MjMgNC41IDE0VjguNVoiIHN0cm9rZS13aWR0aD0iMS40IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNOSAzVjNDNy4zNDMxNSAzIDYgNC4zNDMxNSA2IDZWNy41SDEyVjZDMTIgNC4zNDMxNSAxMC42NTY5IDMgOSAzWiIgc3Ryb2tlLXdpZHRoPSIxLjQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4KPC9zdmc+";